import React from 'react';
import { connect } from 'react-redux';
import {
  FormFieldWrapper as FormFieldsWrapper,
} from 'views/FormComponents';

import {
  Variants,
  PayWhatYouWant,
} from 'payments/views/InitializePurchase';

import CustomFields from 'payments/views/refine/customFields';

import {
  TOTAL_AMOUNT_CAN_CHANGE,
} from 'payments/constants/GlobalConstants';

import {
  handleChangeInput as handleChangeInitializePurchaseInput,
  applyBoost,
} from 'payments/actions/InitializePurchaseActions';

import {
  handleChangeInput as handleChangeRefinePurchaseInput,
} from 'payments/actions/RefinePurchaseActions';

const AddToCartBlock = ({
  initializePurchase,
  refinePurchase,
  handleChangeInitializePurchaseInput,
  handleChangeRefinePurchaseInput,
  applyBoost,
}) => {
  const { form: initializeForm, offer: initializeOffer } = initializePurchase;
  const { form: refineForm, offer: refineOffer } = refinePurchase;

  return (
    <FormFieldsWrapper>
      <Variants
        form={initializeForm}
        variantCategories={initializeOffer.variantCategories}
        onChangeInput={payload =>
          handleChangeInitializePurchaseInput(payload, TOTAL_AMOUNT_CAN_CHANGE)
        }
      />

      <PayWhatYouWant
        form={initializeForm}
        basePrice={initializeOffer.basePrice}
        priceBoost={initializeOffer.priceBoost}
        onChangeInput={payload =>
          handleChangeInitializePurchaseInput(payload, TOTAL_AMOUNT_CAN_CHANGE)
        }
        //This is to change the button status on click
        onUpdate={ (status) =>
           applyBoost(status, true)
        }
      />

      <CustomFields
        form={refineForm}
        offer={refineOffer}
        onChangeInput={handleChangeRefinePurchaseInput}
      />

    </FormFieldsWrapper>
  );
};

const mapStateToProps = ({ payments: { initializePurchase, refinePurchase } }) => ({
  initializePurchase,
  refinePurchase,
});

export default connect(mapStateToProps, {
  handleChangeInitializePurchaseInput,
  handleChangeRefinePurchaseInput,
  applyBoost,
})(AddToCartBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/AddToCartBlock.js